import React from 'react'
import { IStyledComponent } from 'styled-components'

import { Loading } from '../../components/Loading'
import { Tooltip } from '../Tooltip/Tooltip'
import {
  IconButtonDanger,
  IconButtonNeutral,
  IconButtonPrimary,
  IconButtonSecondary,
  IconButtonTertiary,
} from './IconButton.styles'
import { IconButtonProps, IconButtonStyledProps } from './IconButton.types'

function createButtonComponent(Component: IStyledComponent<'web', IconButtonStyledProps>) {
  return ({
    loading,
    disabled,
    icon,
    label,
    hasTooltip = false,
    ...props
  }: IconButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
    const ButtonContent = (
      <Component disabled={disabled || loading} {...props}>
        {loading ? <Loading size="4px" /> : icon}
      </Component>
    )

    return hasTooltip ? (
      <Tooltip content={label} placement="top">
        {ButtonContent}
      </Tooltip>
    ) : (
      ButtonContent
    )
  }
}

const IconButton = () => createButtonComponent(IconButtonPrimary)

IconButton.Primary = createButtonComponent(IconButtonPrimary)
IconButton.Secondary = createButtonComponent(IconButtonSecondary)
IconButton.Tertiary = createButtonComponent(IconButtonTertiary)
IconButton.Danger = createButtonComponent(IconButtonDanger)
IconButton.Neutral = createButtonComponent(IconButtonNeutral)

export { IconButton }
